import React, {useEffect, useState} from 'react';
import Modal from '../Modal/Modal';
import {useSelector} from 'react-redux';
import HelixWrapper from '../../../util/HelixWrapper';
import env from '../../../util/env';
import {labels} from '../../../util/utils';
import Toast from '../BaseComponentWrappers/MotifToast';
import styled from 'styled-components';

function MappingModule(props) {
	const engagement = useSelector((store) => store.engagement);
	const [disableClose, setDisableClose] = useState(true);
	const [toasterVisible, setToasterVisible] = useState(false);

	const clickOnHide = () => {
		if (disableClose) {
			return;
		}

		props.hideMappingModule();
	};

	useEffect(() => {
		function CloseMappingModuleHandler(event) {
			props.hideMappingModule();
		}
		document.addEventListener('HelixMM_CloseCanvasModal', CloseMappingModuleHandler);
		return () => document.removeEventListener('HelixMM_CloseCanvasModal', CloseMappingModuleHandler);
	}, []);

	return (
		<>
			{props.showModal ? (
				<Modal
					show={props.showModal}
					title={labels.manageAccountMapping}
					modalContainerClass={disableClose ? 'helix-mappingmodule-modal' : 'helix-mappingmodule-modal-error'}
					modalbodystyle="helix-mappingmodule-modal-body"
					closeBtnTitle={disableClose ? labels.manageAccountMappingCloseButton : labels.cancelLabel}
					closeTitle={disableClose ? labels.manageAccountMappingCloseButton : labels.cancelLabel}
					modalsize={'large'}
					onHide={clickOnHide}
					isAresView
				>
					<StyledMappingModuleModalBody className="customScrollbar">
						{toasterVisible && (
							<StyledMotifToast
								variant="error"
								className="bannerLabel"
								onClose={() => setToasterVisible(false)}
								children={labels.manageAccountMappingToasterMessage}
							/>
						)}
						<HelixWrapper
							wcName="hx-mapping"
							srcUrl={env.getHelixMappingModuleUrl(
								props.project,
								engagement.engagementId,
								engagement.engagementDescription
							)}
							onErrorCallback={() => {
								setDisableClose(false);
								setToasterVisible(true);
							}}
						/>
					</StyledMappingModuleModalBody>
				</Modal>
			) : null}
		</>
	);
}

export default MappingModule;

const StyledMappingModuleModalBody = styled.section`
	.map-ey-accounts-outer-container {
		background-color: transparent;
	}
`;

const StyledMotifToast = styled(Toast)`
	&.bannerLabel {
		position: absolute;
		width: calc(100% - var(--px-48));
		left: var(--px-24);
		border-radius: var(--px-12);
		top: var(--px-8);
		z-index: 99;
	}
`;
